const RUNE = ({ ...props }) => (
  <svg
    width="248"
    height="248"
    viewBox="0 0 248 248"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28 234L181.274 169.321L132.786 120.028L28 234ZM84.297 70.7981L132.786 120.028L219.397 14L84.297 70.7981V70.7981Z"
      fill="url(#paint0_linear_519_104)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_519_104"
        x1="28"
        y1="124"
        x2="219.397"
        y2="124"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#00CCFF" />
        <stop offset="1" stop-color="#33FF99" />
      </linearGradient>
    </defs>
  </svg>
);
export default RUNE;
